$(document).on("click", "[quickviewactivation]", function(a) {
    a.preventDefault();
    var b = $(this).attr("data-handle"); var ds = $(this).attr('data-description');
    jQuery.getJSON("/products/" + b + ".js", function(ProductFetch) {
      var c = $("[variantslengthThere] ul");$(c).empty();$('[quickviewDescription] p').html(ds);
      $('[quickviewtitle]').html(ProductFetch.title);$('[quickviewimage]').attr('src',ProductFetch.featured_image);
      $('[quickviewPrice]').html('£'+ProductFetch.price/100);
      $(ProductFetch.variants).each(function(b, a) {
        c.append('<li class="list-variantQVC" stock="' + a.available + '"  data-price="' + a.price + '" data-compare-price="' + a.compare_at_price + '"vprice="' + parseFloat(a.price / 100) + '\u20AC" vid="' + a.id + '">' + a.title + "</li>")
      });
      
    })
});


$(document).on("click", ".SelectVariant", function(e){
  e.preventDefault();
  $(this).toggleClass('active-variant');
})


$(document).on("click", "[quickviewactivation]", function(e){
e.preventDefault();
  $('.QuickviewWrpper').addClass('show_popup');$('body').addClass('show_popup');
  
})


$(document).on("click", ".SizeCross", function(e){
e.preventDefault();
  $('.QuickviewWrpper').removeClass('show_popup');$('body').removeClass('show_popup');
  
})

$(document).on("click", ".Variantoption li", function(e){
  e.preventDefault();
  var varid = $(this).attr('vid');
  var demo = $('.AddCartbtn').attr("product-id", varid);
 // alert(varid);
  
  
  
})

$(document).on("click", ".list-variantQVC", function(){ 
var con = $(this).html();
$('.noneoption').html(con);
  })
  



  $(document).on("click", ".AddCartbtn", function(e){
 e.preventDefault();
var attr = $(this).attr('product-id');
    console.log(attr);
    if (attr == '') {
alert('Please Select Size');
    }else{
var variantid = $(this).attr('product-id');
var quan = $('#fillquantity').val();
//alert(variantid);
  //alert(quan);

   $.ajax({
      url: "/cart/add.js",
      type: "POST",
      dataType: "JSON",
       data: { id:variantid , quantity:quan},
      success: function (t) {
      window.location.href = "/cart"
      },
    });

    }
})
